var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"td-avatar"},[_c('lazy-img',{attrs:{"src":_vm.src || _vm.defaultAvatar,"alt":_vm.alt,"error-img":_vm.fallback}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }